var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 22C44 9.84848 34.1515 0 22 0C9.84848 0 0 9.84848 0 22C0 32.9829 8.04375 42.0836 18.5625 43.7336V28.3594H12.9765V22H18.5625V17.1531C18.5625 11.6402 21.8454 8.59375 26.8726 8.59375C29.2789 8.59375 31.7969 9.02344 31.7969 9.02344V14.4375H29.0211C26.2883 14.4375 25.4375 16.1348 25.4375 17.875V22H31.539L30.5637 28.3594H25.4375V43.7336C35.9562 42.0836 44 32.9829 44 22Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5637 28.3594L31.5391 22H25.4375V17.875C25.4375 16.1348 26.2883 14.4375 29.0212 14.4375H31.7969V9.02344C31.7969 9.02344 29.2789 8.59375 26.8727 8.59375C21.8454 8.59375 18.5625 11.6402 18.5625 17.1531V22H12.9766V28.3594H18.5625V43.7336C19.684 43.9098 20.8313 44 22 44C23.1688 44 24.3161 43.9098 25.4375 43.7336V28.3594H30.5637Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.14d351c7ff4f60c9a6a34fbea52a2fe6.svg";
export { ForwardRef as ReactComponent };